import {
  ReactElementFactory,
  SurveyQuestionCheckboxItem,
} from "survey-react-ui";
import { createElement } from "react";
import { Checkbox } from "../ui/checkbox";
import cn from "../../utils/cn";

class SimpleCheckboxItem extends SurveyQuestionCheckboxItem {
  get item() {
    return this.props.item;
  }
  get question() {
    return this.props.question;
  }
  renderCheckbox(isChecked: boolean) {
    const question = this.question;
    const item = this.item;

    const handleOnChange = (checked: boolean) => {
      question.clickItemHandler(item, checked);
    };
    const handleOnMouseDown = () => {
      question.onMouseDown();
    };

    const disabled = question.isReadOnly || !item.isEnabled; //all = preview page

    return (
      <div role="presentation" className={cn("mb-[15px]")}>
        <Checkbox
          label={item.title}
          checked={isChecked}
          value={item.value}
          disabled={disabled}
          id={question.getValueName() ?? question.name}
          onCheckedChange={handleOnChange}
          onMouseDown={handleOnMouseDown}
        />
      </div>
    );
  }
}

ReactElementFactory.Instance.registerElement(
  "simple-checkbox-item",
  (props) => {
    return createElement(SimpleCheckboxItem, props);
  }
);
